module.exports = __webpack_public_path__ + "47c8276114b1d9c05bfd5c2c5403ec9e.svg";